import React from 'react';
import styled from 'styled-components';
import { Body7 } from '@ui';
import { Dot } from './StatusPill';
import { formatConfidence } from './format';
import { CONFIDENCE_TOKENS, tokenFor } from './statusTokens';

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`;

// A confidence as a dot and its word, for table cells where a full pill would crowd the row.
export const ConfidenceDot = ({ confidence, hideLabel = false }) => {
  if (!confidence) return <Body7 isLowContrast>—</Body7>;
  const label = formatConfidence(confidence);
  return (
    <Wrap title={`Confidence: ${label}`} aria-label={`Confidence ${label}`}>
      <Dot $token={tokenFor(CONFIDENCE_TOKENS, confidence)} />
      {!hideLabel && <Body7>{label}</Body7>}
    </Wrap>
  );
};
